/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable quote-props */
/* eslint-disable quotes */
/* eslint-disable comma-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */

import { combineReducers } from 'redux';
import * as _ from 'lodash';

import actionNames from './actionNames';
import healthEntryValuesReducer from '../../redux/ducks/healthEntryValue';

function filesReducer(state = {
  '-1': { isFetching: false, lookup: {}, collection: [] },
}, action) {
  let existingCollection = state.collection;
  const lookup = {};

  switch (action.type) {
    case actionNames.requestFile:
    case actionNames.requestAllFiles:
    case actionNames.receiveAllFiles:
      return _.assign({}, state, {
        [action.payload.profileId]: _.assign({ lookup: {}, collection: [] }, state[action.payload.profileId], action.payload),
      });
    case actionNames.receiveFile:
    case actionNames.updateFile:
      existingCollection = state[action.payload.profileId] ? state[action.payload.profileId].collection : [];
      existingCollection = existingCollection.filter((c) => c.id !== action.payload.id);
      existingCollection.push(action.payload.fileData);
      for (let i = 0; i < existingCollection.length; i++) {
        lookup[existingCollection[i].id] = existingCollection[i];
      }

      return _.assign({}, state, {
        [action.payload.profileId]: _.assign({},
          state[action.payload.profileId],
          {
            lookup,
            collection: existingCollection
          }),
      });
    case actionNames.deleteFile:
      existingCollection = state[action.payload.profileId] ? state[action.payload.profileId].collection : [];
      existingCollection = existingCollection.filter((c) => c.id !== action.payload.id);
      for (let i = 0; i < existingCollection.length; i++) {
        lookup[existingCollection[i].id] = existingCollection[i];
      }
      return _.assign({}, state, {
        [action.payload.profileId]: _.assign({},
          state[action.payload.profileId],
          {
            lookup,
            collection: existingCollection
          }),
      });
    default:
      return state;
  }
}

function profilesReducer(state = {
  collection: [],
  isFetching: false,
}, action) {
  let existingCollection = state.collection;
  let colorIndex = 0;
  const profile = action.payload;

  switch (action.type) {
    case actionNames.setAvailableProfiles:
      return _.assign({}, state, action.payload);
    case actionNames.updateProfile:
      existingCollection = existingCollection.filter((c) => c.id !== action.payload.id);

      colorIndex = existingCollection.length - 1;
      colorIndex = colorIndex >= 3 ? 0 : colorIndex;
      // profile._color = colors[colorIndex];

      existingCollection.push(profile);
      return _.assign({}, state, {
        isFetching: false,
        lastUpdated: new Date().getTime(),
        collection: existingCollection,
      });
    case actionNames.updateProfileTimestamp:
      return _.assign({}, state, {
        lastUpdated: new Date().getTime(),
        collection: existingCollection,
      });
    case actionNames.addProfile:
      existingCollection = existingCollection.filter((c) => c.id !== action.payload.id);
      existingCollection.push(action.payload);
      return _.assign({}, state, {
        collection: existingCollection,
      });
    case actionNames.receivedProfileCollection:
      return _.assign({}, state, {
        collection: action.payload,
        lastUpdated: new Date().getTime(),
        isFetching: false,
      });
    case actionNames.removeProfile:
      existingCollection = existingCollection.filter((c) => c.id !== action.payload.id);
      return _.assign({}, state, {
        collection: existingCollection,
      });
    default:
      return state;
  }
}

function healthEntriesReducer(state = {
  '-1': { isFetching: false, collection: [], lookup: {}, pendingCount: 0 },
}, action) {
  let existingCollection;
  const lookup = {};
  let profileHealthEntries;

  switch (action.type) {
    case actionNames.requestHealthEntry:
    case actionNames.requestAllHealthEntries:
    case actionNames.receiveAllHealthEntries:
      return _.assign({}, state, {
        [action.payload.profileId]: _.assign({
          collection: [],
          lookup: {},
        }, state[action.payload.profileId], action.payload),
      });
    case actionNames.updateHealthEntry:
    case actionNames.receiveHealthEntry:
      profileHealthEntries = state[action.payload.profileId] || { collection: [] };
      existingCollection = profileHealthEntries.collection;
      existingCollection = existingCollection.filter((c) => c.id !== action.payload.healthEntryData.id);
      existingCollection.push(action.payload.healthEntryData);
      for (let i = 0; i < existingCollection.length; i++) {
        lookup[existingCollection[i].id] = existingCollection[i];
      }
      return _.assign({}, state, {
        [action.payload.profileId]: {
          lastUpdated: new Date().getTime(),
          isFetching: false,
          collection: existingCollection,
          lookup,
        },
      });
    case actionNames.deleteHealthEntry:
      profileHealthEntries = state[action.payload.profileId] || { collection: [] };
      existingCollection = profileHealthEntries.collection;
      existingCollection = existingCollection.filter((c) => c.id !== action.payload.id);
      for (let i = 0; i < existingCollection.length; i++) {
        lookup[existingCollection[i].id] = existingCollection[i];
      }
      return _.assign({}, state, {
        [action.payload.profileId]: {
          lastUpdated: new Date().getTime(),
          isFetching: false,
          collection: existingCollection,
          lookup,
        },
      });
    default:
      return state;
  }
}

function pendingHealthEntriesReducer(state = {
  '-1': { isFetching: false, collection: [], lookup: {}, pendingCount: 0 },
}, action) {
  switch (action.type) {
    case actionNames.requestPendingHealthEntries:
    case actionNames.receivePendingHealthEntries:
      return _.assign({}, state, {
        [action.payload.profileId]: _.assign({
          collection: [],
          lookup: {},
        }, state[action.payload.profileId], action.payload),
      });
    default:
      return state;
  }
}

function attachmentsReducer(state = {
  '-1': { parentGroups: {}, attachmentGroups: {}, collection: [], isFetching: false }
}, action) {
  switch (action.type) {
    case actionNames.requestAttachments:
    case actionNames.receiveAttachments:
      return _.assign({}, state, {
        [action.payload.profileId]: _.assign(
          {
            parentGroups: {},
            attachmentGroups: {},
            collection: [],
          }, state[action.payload.profileId], action.payload),
      });
    default:
      return state;
  }
}

function shareCardsReducer(state = {
  '-1': { isFetching: false, collection: [], lookup: {} },
}, action) {
  let profileShareCards = {};
  let existingCollection;

  switch (action.type) {
    case actionNames.requestAllShareCards:
    case actionNames.receiveAllShareCards:
      return _.assign({}, state, {
        [action.payload.profileId]: _.assign({
          collection: [],
          lookup: {},
        }, state[action.payload.profileId], action.payload),
      });
    case actionNames.updateShareCard:
    case actionNames.updateShareCardPasscode:
      profileShareCards = state[action.payload.profileId] || { collection: [] };
      existingCollection = profileShareCards.collection.map((sc) => (sc.id !== action.payload.id ? sc : action.payload.cardData));
      return _.assign({}, state, {
        [action.payload.profileId]: {
          lastUpdated: new Date().getTime(),
          collection: [...existingCollection],
        },
      });
    case actionNames.deleteShareCard:
      profileShareCards = state[action.payload.profileId] || { collection: [] };
      existingCollection = profileShareCards.collection;
      existingCollection = existingCollection.filter((c) => c.id !== action.payload.id);
      return _.assign({}, state, {
        [action.payload.profileId]: {
          lastUpdated: new Date().getTime(),
          collection: [...existingCollection],
        },
      });
    case actionNames.addShareCard:
      profileShareCards = state[action.payload.profileId] || { collection: [] };
      existingCollection = profileShareCards.collection;
      existingCollection.push(action.payload.cardData);
      return _.assign({}, state, {
        [action.payload.profileId]: {
          lastUpdated: new Date().getTime(),
          collection: [...existingCollection],
        },
      });
    default:
      return state;
  }
}

function shareCardDefinitionsReducer(state = {
  '-1': { isFetching: false, collection: [], lookup: {} },
}, action) {
  switch (action.type) {
    case actionNames.requestShareCardDefinitions:
    case actionNames.receiveShareCardDefinitions:
      return _.assign({}, state, {
        [action.payload.profileId]: _.assign({
          collection: [],
          lookup: {},
        }, state[action.payload.profileId], action.payload),
      });
    default:
      return state;
  }
}

function shareCardGroupContentsReducer(state = {
  '-1': { isFetching: false, collection: [], lookup: {} },
}, action) {
  switch (action.type) {
    case actionNames.requestShareCardGroupContents:
    case actionNames.receiveShareCardGroupContents:
      return _.assign({}, state, {
        [action.payload.profileId]: _.assign({
          collection: [],
          lookup: {},
        }, state[action.payload.profileId], action.payload),
      });
    default:
      return state;
  }
}

const apiDataReducer = combineReducers({
  files: filesReducer,
  profiles: profilesReducer,
  healthEntries: healthEntriesReducer,
  pendingHealthEntries: pendingHealthEntriesReducer,
  healthEntryValues: healthEntryValuesReducer,
  attachments: attachmentsReducer,
  shareCards: shareCardsReducer,
  shareCardDefinitions: shareCardDefinitionsReducer,
  shareCardGroupContents: shareCardGroupContentsReducer,
});

export default apiDataReducer;
